import { differenceInCalendarWeeks } from 'date-fns'
export function getView(date) {
  let diffInWeeks = differenceInCalendarWeeks(date, new Date())
  return date.getDay() === 6 && diffInWeeks >= 1 && diffInWeeks <= 24
}
